export class ApiError extends Error {
  status: number;
  body: unknown;
  code?: string;
  constructor(message: string, status: number, body: unknown) {
    super(message);
    this.status = status;
    this.body = body;
    if (body && typeof body === 'object' && 'error' in body) {
      const err = (body as { error?: { code?: string } }).error;
      this.code = err?.code;
    }
  }
}

export interface ApiOpts {
  headers?: Record<string, string>;
}

async function request<T>(path: string, init: RequestInit = {}, opts?: ApiOpts): Promise<T> {
  const res = await fetch(path, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      ...(init.body && !(init.body instanceof FormData) ? { 'Content-Type': 'application/json' } : {}),
      ...init.headers,
      ...(opts?.headers ?? {}),
    },
    ...init,
  });
  const text = await res.text();
  const body = text ? safeJson(text) : null;
  if (!res.ok) {
    let msg = `Запрос ${path} вернул ${res.status}`;
    if (body && typeof body === 'object') {
      const b = body as { message?: string; error?: { message?: string } };
      msg = b.error?.message ?? b.message ?? msg;
    }
    throw new ApiError(msg, res.status, body);
  }
  return body as T;
}

function safeJson(text: string): unknown {
  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}

export const api = {
  get: <T,>(path: string, opts?: ApiOpts) => request<T>(path, {}, opts),
  post: <T,>(path: string, body?: unknown, opts?: ApiOpts) =>
    request<T>(path, { method: 'POST', body: body == null ? null : JSON.stringify(body) }, opts),
  patch: <T,>(path: string, body?: unknown, opts?: ApiOpts) =>
    request<T>(path, { method: 'PATCH', body: body == null ? null : JSON.stringify(body) }, opts),
  delete: <T,>(path: string, opts?: ApiOpts) => request<T>(path, { method: 'DELETE' }, opts),
};
